import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { searchCourseByTitle } from 'actions/search';
import React, { Component } from 'react';
import { Tabs, Tab, translate, Button, Checkbox } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner, ColorLabel, ColorLabelContainer } from 'UI';
import { Search } from 'UI/Inputs';
import './SearchCourses.scss';
import { getSchoolTypes } from 'actions/tenants';

var SearchCourses = /*#__PURE__*/function (_Component) {
  _inherits(SearchCourses, _Component);

  var _super = _createSuper(SearchCourses);

  function SearchCourses(props) {
    var _this;

    _classCallCheck(this, SearchCourses);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.props.schoolTypes.length <= 1 || _this.props.schoolTypes == null)) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.props.getSchoolTypes();

            case 3:
              _this.setState({
                pageloading: false
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onSearch", function () {
      if (_this.state.searchText == null || _this.state.searchText == '') {
        _this.state.searchText = null;
      }

      var _this$state = _this.state,
          searchText = _this$state.searchText,
          schoolType = _this$state.schoolType,
          year = _this$state.year;

      _this.setState({
        selected: [],
        loading: true,
        courses: null,
        showNoSearchResult: false
      });

      _this.props.searchCourseByTitle(searchText, schoolType == 'All' ? '' : schoolType, year == 'All' ? '' : _this.state.year, function (data) {
        _this.setState({
          loading: false,
          courses: data,
          showNoSearchResult: data == null || data.length == 0
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCourseTitle", function (course) {
      var schoolType = _this.props.translate(course.typeOfSchooling);

      return "".concat(course.title, " - ").concat(course.year != null ? course.year : '', " ").concat(course.courseCode, " (").concat(schoolType, ")");
    });

    _defineProperty(_assertThisInitialized(_this), "renderCourse", function (course) {
      if (course.title == '') return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "course",
        key: 'searched-course-' + course.id,
        onClick: function onClick(e) {
          return _this.onSelect(course);
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: _this.state.selected.findIndex(function (selected) {
          return selected.id == course.id;
        }) > -1,
        label: /*#__PURE__*/React.createElement(ColorLabelContainer, null, /*#__PURE__*/React.createElement(ColorLabel, {
          content: _this.getCourseTitle(course),
          color: course.colorCode
        }))
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (course) {
      var foundIndex = _this.state.selected.findIndex(function (selected) {
        return selected.id == course.id;
      });

      if (foundIndex > -1) {
        _this.setState({
          selected: _this.state.selected.filter(function (selected) {
            return selected.id != course.id;
          })
        });
      } else {
        _this.setState({
          selected: [].concat(_toConsumableArray(_this.state.selected), [course])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (event) {
      event.preventDefault();

      if (_this.props.onSubmit != null) {
        _this.props.onSubmit(_this.state.selected);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSchoolTypeChange", function (event) {
      _this.setState({
        schoolType: event.target.value,
        year: 'All'
      }, function () {
        _this.onSearch();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onYearChange", function (event) {
      _this.setState({
        year: event.target.value
      }, function () {
        _this.onSearch();
      });
    });

    _this.state = {
      pageloading: true,
      courses: null,
      schoolType: 'All',
      year: 'All',
      searchText: null,
      showNoSearchResult: false,
      selected: []
    };
    _this.years = ["All", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    return _this;
  }

  _createClass(SearchCourses, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$schoolTyp,
          _this$props$schoolTyp2;

      var translate = this.props.translate;
      var courses = [];

      if (this.state.courses != null) {
        courses = this.state.courses.sort(function (a, b) {
          return _this2.getCourseTitle(a).localeCompare(_this2.getCourseTitle(b));
        });
      }

      var selectedSchoolType = (_this$props$schoolTyp = this.props.schoolTypes) === null || _this$props$schoolTyp === void 0 ? void 0 : _this$props$schoolTyp.find(function (type) {
        return type.typeId == _this2.state.schoolType;
      });

      if (this.state.pageloading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "container course-selector form form-component",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: 0
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Add curriculum to group')), /*#__PURE__*/React.createElement("div", null, this.props.translate('Search for curriculum'), " (", this.props.translate('enter to search'), ")"), /*#__PURE__*/React.createElement(Search, {
        onSubmit: this.onSearch,
        loading: this.state.loading,
        onChange: function onChange(value) {
          _this2.setState({
            searchText: value
          });
        },
        allowEmpty: true
      })), this.props.schoolTypes != null && this.props.schoolTypes.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "df",
        style: {
          marginTop: '1.5rem',
          marginBottom: '1rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          width: '47%',
          padding: 0,
          marginRight: '1rem'
        }
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          margin: 0
        }
      }, this.props.translate('Filter')), /*#__PURE__*/React.createElement("div", {
        className: "select",
        style: {
          marginTop: '.5rem'
        }
      }, /*#__PURE__*/React.createElement("select", {
        name: "schoolType",
        value: this.state.schoolType,
        onChange: this.onSchoolTypeChange
      }, /*#__PURE__*/React.createElement("option", {
        value: "All"
      }, this.props.translate('All')), (_this$props$schoolTyp2 = this.props.schoolTypes) === null || _this$props$schoolTyp2 === void 0 ? void 0 : _this$props$schoolTyp2.sort(function (a, b) {
        return translate(a.typeId).localeCompare(translate(b.typeId));
      }).map(function (schoolType, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: index,
          value: schoolType.typeId
        }, _this2.props.translate(schoolType.typeId));
      })))), selectedSchoolType != null && selectedSchoolType.maxYear != null && selectedSchoolType.minYear != null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: 0,
          width: 'auto',
          flex: 1,
          marginLeft: '2rem'
        }
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          margin: 0
        }
      }, this.props.translate('course-year')), /*#__PURE__*/React.createElement("div", {
        className: "select",
        style: {
          marginTop: '8px'
        }
      }, /*#__PURE__*/React.createElement("select", {
        name: "year",
        value: this.state.year,
        onChange: this.onYearChange
      }, this.years.filter(function (year) {
        if (year == 'All') {
          return true;
        }

        return year >= (selectedSchoolType === null || selectedSchoolType === void 0 ? void 0 : selectedSchoolType.minYear) && year <= (selectedSchoolType === null || selectedSchoolType === void 0 ? void 0 : selectedSchoolType.maxYear);
      }).map(function (year, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: index,
          value: year
        }, _this2.props.translate(year));
      })))) : null) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }), /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Curriculums')
      }, this.state.searchText != null && this.state.searchText.length > 0 && this.state.showNoSearchResult ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, this.props.translate('No search results')) : null, courses.map(function (course) {
        return _this2.renderCourse(course);
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2.5rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: this.state.selected.length == 0,
        onClick: this.onSubmit
      }, this.props.translate('Add'))));
    }
  }]);

  return SearchCourses;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    schoolTypes: state.Tenant.schoolTypes
  };
}

export default connect(mapStateToProps, {
  searchCourseByTitle: searchCourseByTitle,
  getSchoolTypes: getSchoolTypes
})(SearchCourses);